import styled from 'styled-components'
import { colors } from '../../../../../theme/theme';

export const CardBody = styled.div`
    // min-width: 380px;
    /* max-height: 300px; */
    padding: 24px;
    box-shadow: 0px 2px 8px 0px rgba(51, 51, 51, 0.15);
    border-radius: 4px;
    h1 { 
        font-size: 20px;
        color: #333333;
        font-weight: 700;
    }
`;
export const CardTitle = styled.div` 
    text-align: left;
    border-bottom: 1px solid #EEEEEE;
    padding: 6px;
`;

export const CardMain = styled.div`
    .circle {
        height: 15px;
        width: 15px;
        background-color: #555;
        border-radius: 50%;
        display: inline-block;
        margin-right: 5px;
    }
`;

export const CardFooter = styled.div` 
    text-align: center;
    padding: 10px;
    padding-bottom: 0px;
    border-top: 1px solid #EEEEEE;
    a {   
        font-size: 18px;
        color: ${colors.mainColors.blueberry};

        &:hover { 
            color: ${colors.mainColors.blueberry};
        }
    }
`;